export default __webpack_public_path__ + "static/03-acd8d0c5fce6014fe0ee8279ee38308f.png";